export default function MyProfileBankDetails({ employee, editMode, setValue }) {
  if (!employee) return <div className="loading">Loading...</div>;

  return (
    <div className="white-box">
      <div className="subtitle">Bank Information</div>
      <div className="row col-2 main-gap">
        <div className="label-row">
          <label>Account Name</label>
          <input
            value={employee.bankAccountName || ""}
            readOnly={!editMode}
            onChange={(e) => setValue("bankAccountName", e.target.value)}
          />
        </div>
        <div className="label-row">
          <label>Account Number</label>
          <input
            value={employee.bankAccountNumber || ""}
            readOnly={!editMode}
            onChange={(e) => setValue("bankAccountNumber", e.target.value)}
          />
        </div>
        <div className="label-row">
          <label>Swift/BIC</label>
          <input
            value={employee.bankSwiftBic || ""}
            readOnly={!editMode}
            onChange={(e) => setValue("bankSwiftBic", e.target.value)}
          />
        </div>
        <div className="label-row">
          <label>Account ID CLABE</label>
          <input
            value={employee.bankAccountIdClabe || ""}
            readOnly={!editMode}
            onChange={(e) => setValue("bankAccountIdClabe", e.target.value)}
          />
        </div>
        <div className="label-row">
          <label>Bank Name</label>
          <input value={employee.bankName || ""} readOnly={!editMode} onChange={(e) => setValue("bankName", e.target.value)} />
        </div>
        <div className="label-row">
          <label>Bank Address</label>
          <input
            value={employee.bankAddress || ""}
            readOnly={!editMode}
            onChange={(e) => setValue("bankAddress", e.target.value)}
          />
        </div>
        <div className="label-row">
          <label>City</label>
          <input value={employee.bankCity || ""} readOnly={!editMode} onChange={(e) => setValue("bankCity", e.target.value)} />
        </div>
        <div className="label-row">
          <label>State</label>
          <input value={employee.bankState || ""} readOnly={!editMode} onChange={(e) => setValue("bankState", e.target.value)} />
        </div>
        <div className="label-row">
          <label>ZIP</label>
          <input value={employee.bankZip || ""} readOnly={!editMode} onChange={(e) => setValue("bankZip", e.target.value)} />
        </div>
        <div className="label-row">
          <label>Phone Number</label>
          <input value={employee.bankPhone || ""} readOnly={!editMode} onChange={(e) => setValue("bankPhone", e.target.value)} />
        </div>
      </div>
    </div>
  );
}
